var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.459,
    height: 20.827,
    viewBox: "0 0 22.459 20.827",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reports_Icon",
    "data-name": "Reports Icon",
    transform: "translate(-894.327 13470)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "report",
    transform: "translate(894.448 -13470)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38101",
    "data-name": "Path 38101",
    d: "M20.039,0H2.42A2.34,2.34,0,0,0,0,2.244V14.213a2.34,2.34,0,0,0,2.42,2.244H8l1.849,3.43a1.6,1.6,0,0,0,1.376.94,1.6,1.6,0,0,0,1.376-.94l1.849-3.43h5.584a2.34,2.34,0,0,0,2.42-2.244V2.244A2.34,2.34,0,0,0,20.039,0Zm-8.81,14.5a2,2,0,0,1-2.067-1.917,2,2,0,0,1,2.067-1.917A2,2,0,0,1,13.3,12.579,2,2,0,0,1,11.229,14.5ZM13.3,7.351a2,2,0,0,1-2.068,1.917A2,2,0,0,1,9.162,7.351V4.531a2,2,0,0,1,2.067-1.917A2,2,0,0,1,13.3,4.531Zm0,0",
    transform: "translate(-0.121)",
    fill: "#6e6e6e"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4764",
    "data-name": "Rectangle 4764",
    width: 15,
    height: 14,
    transform: "translate(898 -13469)",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13515",
    "data-name": "Group 13515"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_442",
    "data-name": "Line 442",
    y2: 6,
    transform: "translate(905.827 -13466.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_443",
    "data-name": "Line 443",
    transform: "translate(905.827 -13457)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/Reports Icon.ce85a59e.svg";
export { ForwardRef as ReactComponent };